import { useContext } from 'react';

import {
  VersionExpectationStateValue,
  VersionExpectationsContext,
} from './version-expectations.context';

export const useVersionExpectations = (): VersionExpectationStateValue => {
  const context = useContext(VersionExpectationsContext);

  if (!context) {
    throw new Error(
      'useVersionExpectations must be used within the context of a VersionExpectationsProvider',
    );
  }

  return context;
};
